import { render, staticRenderFns } from "./ChatSettingSwitch.vue?vue&type=template&id=28a2e288&scoped=true"
import script from "./ChatSettingSwitch.vue?vue&type=script&lang=js"
export * from "./ChatSettingSwitch.vue?vue&type=script&lang=js"
import style0 from "./ChatSettingSwitch.vue?vue&type=style&index=0&id=28a2e288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2e288",
  null
  
)

export default component.exports